import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-lecture-plan',
  templateUrl: './lecture-plan.component.html',
  styleUrls: ['./lecture-plan.component.css']
})
export class LecturePlanComponent implements OnInit {
  BookTitleList = [];
  ChapterHeadingList = [];
  ChapterTopicList = [];
  SearchChapterHeadingList = [];
  SearchChapterTopicList = [];
  dropdownSettings: any = {};
  selectedItems: any = [];

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  constructor(private learningservice: LearningService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService, private _sanitizer: DomSanitizer) { }

  
  Content: '';
  Submitted=false;
  TeachingModel = {
    TeachingID: 0,
    ClassID: 0,
    SectionID: 0,
    SubjectID: 0,
    BookTitleID: 0,
    ChapterID: 0,
    TopicID: 0,
    StaffID: 0,
    SectionArray: [],
  };

  ContentModel = {
    TeachingResourceID:0,
    TeachingID: 0,
    ContentTitle: '',
    YouTubeUrls: '',
    IsActive: true,
    IsShared: false,
    ResourceType: '0',
    ResourcePath: '',
    ResourceName: '',
   };
  Clear() {
    this.TeachingModel.TeachingID = 0;
    this.TeachingModel.BookTitleID = 0;
    this.TeachingModel.ChapterID = 0;
    this.TeachingModel.TopicID = 0;
    this.TeachingModel.StaffID = 0;
    this.TeachingModel.ClassID = 0;
    this.TeachingModel.SubjectID = 0;
    this.Content = '';
    this.TeachingModel.SectionArray = [];
    this.Submitted = false;
    this.Import=false;
  }
  Import=false;
  TeachingList = [];
  GetAllLearningTeaching() {
    this.TeachingModel.StaffID = 0;
    this.TeachingModel.SectionArray = [];
    this.TeachingResourceList=[];
    this.spinnerService.show();
    this.learningservice.GetAllLearningTeaching(JSON.stringify(this.TeachingModel)).subscribe((data: any) => {
      this.TeachingList = data.TeachingList; 
      if(this.TeachingList!=null && this.TeachingList.length>0)    {
        var SectionIDs = this.TeachingList[0].SectionIDs != null ? this.TeachingList[0].SectionIDs.split(',') : '';
        for (var i = 0; i < this.SectionList.length; i++) {
          for (var j = 0; j < SectionIDs.length; j++) {
            if (SectionIDs[j] == this.SectionList[i].ItemId) {
              let item = {
                ItemId: this.SectionList[i].ItemId,
                ItemName: this.SectionList[i].ItemName
              }
              this.selectedItems.push(item)
              break;
            }
          }
        }    
    
        this.TeachingModel.SectionArray = this.selectedItems;
        this.TeachingModel.StaffID = this.TeachingList[0].StaffID; 
        this.TeachingModel.TeachingID=this.TeachingList[0].TeachingID; 
        this.ContentModel.TeachingResourceID = 0;
        this.Import=false;
        this.GetAllTeachingResource();
      }  
      else{
        this.Import=true;
      }
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  ValidityState() {
    return this.TeachingModel.BookTitleID == 0 || this.TeachingModel.TopicID == 0 || this.TeachingModel.ClassID == 0 || this.TeachingModel.StaffID == 0;
  }


  SaveLearningTeaching() {
    this.Submitted=true;
   if (!this.ValidityState()) {
    this.ClassSectionList=[];
    for (var j = 0; j < this.TeachingModel.SectionArray.length; j++) {
     var ItemID={
     'SectionID':this.TeachingModel.SectionArray[j].ItemId
     }
     this.ClassSectionList.push(ItemID);
    }
      this.spinnerService.show();
      this.learningservice.SaveLearningTeaching(JSON.stringify(this.TeachingModel),this.Content,JSON.stringify(this.ClassSectionList)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllLearningTeaching();
          this.TeachingModel.TeachingID=data.TeachingID;
        }
        this.Submitted=false;
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

  SaveImportLearningTeaching() {
    this.Submitted=true;
   if (!this.ValidityState()) {
    this.ClassSectionList=[];
    for (var j = 0; j < this.TeachingModel.SectionArray.length; j++) {
     var ItemID={
     'SectionID':this.TeachingModel.SectionArray[j].ItemId
     }
     this.ClassSectionList.push(ItemID);
    }
      this.spinnerService.show();
      this.learningservice.SaveImportLearningTeaching(JSON.stringify(this.TeachingModel),this.Content,JSON.stringify(this.ClassSectionList)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllLearningTeaching();
          this.TeachingModel.TeachingID=data.TeachingID;
        }
        this.Submitted=false;
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };
  Edit(obj) {
    this.TeachingModel.TeachingID = obj.TeachingID;
    this.TeachingModel.ClassID = obj.ClassID;
    this.GetSection();
    this.GetSubjectTeacher();
    this.GetSubjectBookTitle();
    this.TeachingModel.StaffID = obj.StaffID;
    this.TeachingModel.BookTitleID = obj.BookTitleID;
    this.GetChapterHeading();
    this.TeachingModel.ChapterID = obj.ChapterID;
    this.GetChapterTopic();
    this.TeachingModel.TopicID = obj.TopicID;
    this.Content = obj.Description;
    var SectionIDs = obj.SectionIDs != null ? obj.SectionIDs.split(',') : '';
    for (var i = 0; i < this.SectionList.length; i++) {
      for (var j = 0; j < SectionIDs.length; j++) {
        if (SectionIDs[j] == this.SectionList[i].ItemId) {
          let item = {
            ItemId: this.SectionList[i].ItemId,
            ItemName: this.SectionList[i].ItemName
          }
          this.selectedItems.push(item)
          break;
        }
      }
    }

    this.TeachingModel.SectionArray = this.selectedItems;
    this.GetAllTeachingResource();
  
  }
  SelectedFileForUpload: any;
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };
 
 
  ClearSave() {
    this.ContentModel.TeachingResourceID = 0;
    this.ContentModel.ResourceType = '0';
    this.ContentModel.ResourcePath = '';
    this.ContentModel.ResourceName = '';
    this.ContentModel.IsShared = false;
    this.Content = '';
    this.SubmittedResource = false;
    if (this.SelectedFileForUpload != undefined && this.SelectedFileForUpload != null) {
      this.fileUploader.nativeElement.value = null;
      this.SelectedFileForUpload = '';
    }

  }
 


  SubmittedResource = false;
  ClassSectionList=[];
  SaveTeachingResource() {
    this.SubmittedResource = true;
    if (!this.ValidityState()) {     
     
      this.spinnerService.show();
      this.learningservice.SaveTeachingResource(JSON.stringify(this.ContentModel), this.SelectedFileForUpload,this.TeachingModel.TeachingID).subscribe((data: any) => {
       if (data.webResponse.Status) {
          this.ClearSave();
          this.GetAllTeachingResource();
        }
        this.SubmittedResource = false;
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();      
      });
    }
  };

  TeachingResourceList = [];
  GetAllTeachingResource() {
    this.spinnerService.show();
    this.learningservice.GetAllTeachingResource(this.TeachingModel.TeachingID).subscribe((data: any) => {
      this.TeachingResourceList = data.TeachingResourceList;
      if (this.TeachingResourceList != null) {
        for (var i = 0; i < this.TeachingResourceList.length; i++) {
          this.TeachingResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.TeachingResourceList[i].YouTubeUrls);

        }

      }
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  DeleteTeachingResource(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    if (confirm("Are you sure to delete this resource !")) {
      this.spinnerService.show();
      this.learningservice.DeleteTeachingResource(item.TeachingResourceID).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllTeachingResource();
          this.ClearSave();
        }

        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

  safeSrc: SafeResourceUrl;
  embedURL(url) {

    let stringToSplit = url;
    let x = stringToSplit.split("https://www.youtube.com/watch?v=");
    var safeSrc = "https://www.youtube.com/embed/" + x[1] + "?loop=1" + "&origin=1&rel=1&showinfo=1"
    return this._sanitizer.bypassSecurityTrustResourceUrl(safeSrc);



  }

  MarkShareTeachingResourse(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    this.ContentModel.IsShared = item.IsShared == true ? false : true;
    this.spinnerService.show();
    this.learningservice.MarkShareTeachingResourse(this.ContentModel.TeachingResourceID,this.ContentModel.IsShared).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllTeachingResource();
      }
     
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };
  
  EditResource(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    this.ContentModel.ResourceType = item.ResourceType;
    this.ContentModel.ResourcePath = item.ResourcePath != null ? item.ResourcePath : '';
    this.ContentModel.IsShared = item.IsShared;
    this.ContentModel.ResourceName = item.ResourceName;
    this.Content = item.Description;
    this.ContentModel.TeachingID = item.TeachingID;
  }

  EditTeaching(obj){
    this.TeachingModel.ClassID = obj.ClassID;
    this.GetSection();
    this.GetSubjectTeacher();
    this.GetSubjectBookTitle();
    this.TeachingModel.BookTitleID = obj.BookTitleID;
    this.GetChapterHeading();
    this.TeachingModel.ChapterID = obj.ChapterID;
    this.GetChapterTopic();
    this.TeachingModel.TopicID = obj.TopicID;
    this.GetAllLearningTeaching();
  }
  ngOnInit() {
    if (window.history.state.KBDetails != undefined) {
      this.EditTeaching(window.history.state.KBDetails);
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.GetClass();
    this.GetSection();
    this.GetClassSubject();
    this.GetSubjectBookTitle();   
  }
  ClassList = [];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }
  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }
  ClassSubjectList=[];
  GetClassSubject() {
    this.TeachingModel.SubjectID=0;
    var ItemBO={
     'ItemID':this.TeachingModel.ClassID
   }
    this.LookupService.GetLookupsList('ClassSubject', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ClassSubjectList = data.LookupItems;
    });

  }
 
  SectionList = [];
  GetSection() {
   var ItemBO = {
      'ItemID': this.TeachingModel.ClassID
    }
    this.LookupService.GetLookupsList('LPSection', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.SectionList.splice(0,1);
    });
  }

  SubjectBookTitleList = [];
  GetSubjectBookTitle() {
    // this.TeachingModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.TeachingModel.ClassID
    }
    this.LookupService.GetLookupsList('SubjectBookTitle', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectBookTitleList = data.LookupItems;
    });
  }

  SetID(){
    this.TeachingResourceList=[];
    this.GetSubjectBookTitle();
    this.GetSection();
    this.GetSubjectTeacher();
    this.TeachingModel.BookTitleID=0;
    this.TeachingModel.ChapterID=0;
    this.TeachingModel.TopicID=0;
    this.TeachingModel.StaffID=0;
    this.TeachingModel.SectionArray = [];
  }
  SubjectTeacherList = [];
  GetSubjectTeacher() {
    this.TeachingModel.StaffID = 0;
    var ItemBO = {
      'ItemID': this.TeachingModel.ClassID
    }
    this.LookupService.GetLookupsList('LNSubjectTeacher', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectTeacherList = data.LookupItems;
    });
  }
  GetChapterHeading() {
   this.TeachingModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.TeachingModel.BookTitleID
    }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterHeadingList = data.LookupItems;
    });
  }

  GetChapterTopic() {
    this.TeachingModel.TopicID = 0;
    this.TeachingModel.StaffID=0;
    this.TeachingModel.SectionArray = [];
    var ItemBO = {
      'ItemID': this.TeachingModel.ChapterID
    }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterTopicList = data.LookupItems;
    });
  }
  
}





